import React from 'react';
import { avatarPalette } from './avatar';
import styles from './board.module.css';

export const BoardCard = ({
  title = '—',
  subtitle = '',
  meta = '',
  badge = null,
  labels = [],
  actions = null,
  onClick
}) => {
  const { bg, fg } = avatarPalette(title);
  const initial = (title || '—').charAt(0).toUpperCase();

  return (
    <div
      className={styles.card}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && onClick && onClick()}
    >
      <div className={styles.cardTop}>
        <div className={styles.cardAvatar} style={{ background: bg, color: fg }}>
          {initial}
        </div>
        <div className={styles.cardMain}>
          <span className={styles.cardName}>{title}</span>
          {subtitle && <div className={styles.cardSub}>{subtitle}</div>}
          {meta && <div className={styles.cardMeta}>{meta}</div>}
        </div>
        {badge !== null && badge !== undefined && badge !== '' && (
          <span className={styles.cardBadge}>{badge}</span>
        )}
        {actions && (
          <div className={styles.cardActions} onClick={(e) => e.stopPropagation()}>
            {actions}
          </div>
        )}
      </div>
      {labels.length > 0 && (
        <div className={styles.cardLabels}>
          {labels.map((label) => (
            <span
              key={label.id}
              className={styles.cardLabelChip}
              style={label.color ? { borderColor: label.color, color: label.color } : undefined}
            >
              {label.name}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};
